module.exports = __webpack_public_path__ + "static/media/ic_upload.301ea805.svg";